/* BASE URL */
const GB_API_BASE_URL = process.env.REACT_APP_GB_API_BASE_URL
const GB_API_SUB_DIRECTORY_PATH = process.env.REACT_APP_GB_API_SUB_DIRECTORY_PATH
const ATOM_API_BASE_URL = window.mbtGlobal.atomUrl;
// const COMMON_DIR_URL = process.env.REACT_APP_GB_COMMON_SUB_DIRECTORY_PATH
const ATOM_API_ADDRSEARCH_BASE_URL = window.mbtGlobal.atomAddrsearchUrl;
/* SIGN IN URL */
//export const GB_SIGN_IN_URL = process.env.REACT_APP_GB_SIGN_IN_URL

/* ATOM APIs */
export const GET_ZIPCODE_URL = ATOM_API_BASE_URL + '/atomapi/v1/addresslookup/addresses/zip?zipcityterm='
export const API_ERROR_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/ErrLogger/GetLog'
export const GET_UNITS_URL = ATOM_API_BASE_URL + '/atomapi/v1/addresslookup/addresses/units?baseAddressId='
export const GET_LOCUS_UNITS_URL = ATOM_API_ADDRSEARCH_BASE_URL + '/locus-typeahead/address/typeahead-unit?locusID=' // 300003293740&unitterm=7&size=10
export const GET_LOCUS_URL =  '/locus-typeahead/address/typeahead-loc-unit?locusID=' 

/* LQ */
//export const INITIATE_GLOBAL_SESSION_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/Qualify/LQFullPageEntry'
// export const GET_APIGEE_TOKEN_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/MicroBiz/GetApigeeToken'
export const GET_APIGEE_TOKEN_URL = '/foryoursmallbiz/smb/api/MicroBiz/GetApigeeToken'


//export const DO_LOOP_QUALIFICATION_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/Qualify/DoLoopQualification?BDVCETC=N&cetctest=N'
//export const GET_GBCOMCREADLE_DETAILS_URL = GB_API_BASE_URL + '/foryoursmallbiz/gbcomcradle/newConnect'

// UI Event Logging
//export const POST_UI_EVENT_LOGGING = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/EventLog/Save'


// LQ Street Address Validation URLs
// export const GET_STREET_ADDRESS_URL = ATOM_API_ADDRSEARCH_BASE_URL + '/address/typeahead-address?streetterm='
export const GET_ATOM_STREET_ADDRESS_URL = ATOM_API_ADDRSEARCH_BASE_URL + '/locus-typeahead/address/typeahead-address?countrycode=USA&streetterm='
export const FIOS_QUALIFICATION_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/Qualify/GetFiosQualification'
export const CHECK_AVAILABILITY_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + '/api/Qualify/CheckAvailability'
export const GET_AB_LOGIC = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + "/api/Qualify/GetABLogic";
//Payment API 
export const GET_PAYMENT_POST_URL = GB_API_BASE_URL + GB_API_SUB_DIRECTORY_PATH + 'checkoutsvc/mbt/prospect/checkout/validateAndSaveCard'
